export const getDDDAndNumberOfPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) {
    return {};
  }

  const phoneOnlyNumber = phoneNumber.replace(/\D/g, "");
  const phoneDDD = phoneOnlyNumber.slice(0, 2);
  const phone = phoneOnlyNumber.slice(2, phoneOnlyNumber.length);

  return {
    phoneDDD,
    phone
  };
};

export const formatToBRNumber = (value: number) => {
  return Intl.NumberFormat("pt-BR").format(value);
};

/**
 * Removes CPF mask and returns only numeric characters
 * @param cpf - CPF string with or without mask
 * @returns Clean CPF string with only numbers
 */
export const getCleanCPF = (cpf: string): string => {
  if (!cpf) return "";
  return cpf.replace(/\D/g, "");
};

/**
 * Removes accents/diacritics from a string
 * e.g. "Célio dos Santos" -> "Celio dos Santos"
 * @param str - String with potential accents
 * @returns String without accents
 */
export const removeAccents = (str: string): string => {
  if (!str) return "";
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

/**
 * Sanitizes name input by allowing only letters (including accented) and spaces.
 * Accents are preserved in the input; use removeAccents() when sending to backend.
 * Removes special characters like !@#$%¨&* and numbers.
 * @param value - Raw input value
 * @returns Sanitized string with only letters and spaces
 */
export const sanitizeNameInput = (value: string): string => {
  if (!value) return "";
  return value.replace(/[^\p{L}\s]/gu, "");
};
